import { useState, useEffect } from 'preact/hooks';
import useVendor from './useVendor';
import { publicConfigurationUrl } from '../config/serviceUrl';
import { HookState } from '../types/hooks';

/**
 * Fetch storefront public configuration
 * @return {{data: Object|null, loading: boolean, error: boolean}}
 */
export default function useStorefrontConfig(): HookState {
    const [status, setStatus] = useState({
        loading: true,
        error: false,
        data: null,
    });

    const vendor = useVendor();

    useEffect(() => {
        (async () => {
            // Declaring these variables inside try{...} statement
            // leads to a babel compilation error when running Jest tests.
            let response, configuration;

            try {
                response = await fetch(publicConfigurationUrl + vendor);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`);
                }

                configuration = await response.json();
                setStatus({ loading: false, error: false, data: configuration });
            } catch (error: any) {
                console.error(`Public configuration error: ${error.message}`);
                setStatus({ loading: false, error: true, data: null });
            }
        })();
    }, [vendor]);

    return status;
}
